import TimeoutError from '../errors/TimeoutError';

export async function execWithTimeout<T>(
  promise: Promise<T>,
  operation: string,
  timeoutMs: number,
): Promise<T> {
  // eslint-disable-next-line @typescript-eslint/init-declarations
  let timeoutId: ReturnType<typeof setTimeout>;

  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new TimeoutError(
        `Operation "${ operation }" timed out after ${ timeoutMs }ms`,
        'operation_timeout',
        { operation, timeoutMs },
      ));
    }, timeoutMs);
  });

  return await Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timeoutId);
  });
}

export function withTimeout(timeoutMs: number, operation?: string) {
  return (_target: object, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor => {
    const original = descriptor.value;
    const operationName = operation ?? propertyKey;

    descriptor.value = async function(this: unknown, ...args: unknown[]): Promise<unknown> {
      return await execWithTimeout(original.apply(this, args) as Promise<unknown>, operationName, timeoutMs);
    };

    return descriptor;
  };
}
